import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { BeneficiaryService } from 'src/app/services/beneficiary.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class BeneficiariesEditEffects {
  constructor(private store: Store<any>,
    private actions$: Actions,
    private router: Router,
    public toastr: ToastrService,
    private service: BeneficiaryService) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getMemberBeneficiaries(action.accountId)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

  submit$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.SubmitRequestAction),
    switchMap((action: any) => this.service.updateBeneficiaries(action.accountId, action.payload)),
    map((data: any) => {
      this.toastr.success(data.message);
      return ActionsList.SubmitResponseAction({ payload: data });
    })
  ));

}
